import React, { useState } from 'react';
import { 
  first,
  second,
  third
} from "constants/menu";
import { ROUTES } from "utils/routes";

const Navbar = () => {

  const [showNav, setShowNav] = useState(false);

  return (
    <nav id="navbartop" className="relative bg-white shadow w-full">
      <div className="px-6 py-4 mx-auto md:flex md:justify-between md:items-center">
        <div className="flex items-center justify-between">
          <a target="_blank" href="https://www.piano-piano.org">
            <img
              className="w-48"
              src="https://piano-piano.org/wp-content/uploads/2022/09/logo.png"
              alt="Logo piano piano"
            />
          </a>

          <div className="flex lg:hidden">
            <button onClick={() => setShowNav(!showNav)} type="button" className="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400" aria-label="toggle menu">
              {!showNav &&
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="block md:hidden w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              }

              {showNav && <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
              }
            </button>
          </div>
        </div>

        <div className={`${showNav ? 'block translate-x-0 opacity-100 ' : ' hidden opacity-0 -translate-x-full '}${' absolute inset-x-0 w-full z-10 px-6 py-4 transition-all duration-300 ease-in-out bg-white md:mt-0 md:p-0 md:top-0 md:relative md:bg-transparent md:w-auto md:opacity-100 md:translate-x-0 md:flex md:items-center'}`}>
          <div id="navbar" className="flex flex-col md:flex-row items-center md:mx-6 space-x-6 h-full z-50">
            <div className="relative group px-3 py-2">
              <a href="#" className="my-2 fond-medium text-black transition-colors duration-300 transform hover:text-pblue md:my-0" >L’association</a>
              <div className="hidden absolute top-0 -left-2 transition group-hover:translate-y-5 translate-y-0 opacity-0  group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50 w-60 transform">
                <div className="relative top-12 p-6 bg-white shadow-xl w-full">
                  <div className="w-10 h-10 bg-white transform rotate-45 absolute top-0 z-0 -translate-x-4 transition-transform group-hover:translate-x-3 duration-500 ease-in-out"></div>
                  <div className="relative z-10">
                    <ul className="mt-3 text-[15px] p-2 space-y-5">
                      {first.map((it, index) => (
                        <li key={index}>
                          <a 
                            target="_blank"
                            href={it.path}
                          >
                           {it.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative group px-3 py-2">
              <a className="my-2 fond-bold text-black transition-colors duration-300 transform hover:text-blue-500 md:my-0" target="_blink" href="https://piano-piano.org/festival">Festival</a>
            </div>
            
            <div className="relative group px-3 py-2">
              <a href="#" className="my-2 fond-bold text-black transition-colors duration-300 transform hover:text-pblue md:my-0" >Pédagogie</a>
              <div className="hidden absolute top-0 -left-2 invisible transition group-hover:translate-y-5 translate-y-0 opacity-0  group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50 w-60 transform">
                <div className="relative top-12 p-6 bg-white shadow-xl w-full">
                  <div className="w-10 h-10 bg-white transform rotate-45 absolute top-0 z-0 -translate-x-4 transition-transform group-hover:translate-x-3 duration-500 ease-in-out"></div>
                  <div className="relative z-10">
                    <ul className="mt-3 text-[15px] p-2 space-y-5">
                      {second.map((it, index) => (
                        <li key={index}>
                          <a 
                            target="_blank"
                            href={it.path}
                            >
                           {it.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative group px-3 py-2">
              <a href="#" className="my-2 fond-bold text-black transition-colors duration-300 transform hover:text-pbluemd:my-0" >Découvrir</a>
              <div className="hidden absolute top-0 -left-2 transition group-hover:translate-y-5 translate-y-0 opacity-0  group-hover:opacity-100 group-hover:visible duration-500 ease-in-out group-hover:transform z-50 w-60 transform">
                <div className="relative top-12 p-6 bg-white shadow-xl w-full">
                  <div className="w-10 h-10 bg-white transform rotate-45 absolute top-0 z-0 -translate-x-4 transition-transform group-hover:translate-x-3 duration-500 ease-in-out"></div>
                  <div className="relative z-10">
                    <ul className="mt-3 text-[15px] p-2 space-y-5">
                      {third.map((it, index) => (
                        <li key={index}>
                          <a 
                            target="_blank"
                            href={it.path}
                            >
                           {it.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
              <a className="my-2 bg-pblue py-2 font-bold px-6 text-white transition-colors duration-300 transform hover:text-blue-500 md:my-0 z-20" href={ROUTES.HOME}>oPPDb</a>
              <a href={ROUTES.DASHBOARD}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </a>
          </div>

          <div className="flex justify-center md:block z-10 ">
          </div>
        </div>
      </div>
    </nav>
  )
}
export default React.memo(Navbar);
